
const DocTypeCard = ({ title }) => {

  const getInitials = (text) => {
    if (!text) return "";
    const words = text.trim().split(" ");
    const first = words[0]?.charAt(0) || "";
    const last = words.length > 1 ? words[words.length - 1]?.charAt(0) : "";
    return (first + last).toUpperCase();
  };

  return (
    <div
      className="card border-0 shadow-sm p-3 h-100 d-flex flex-row align-items-center justify-content-between"
      style={{ cursor: "pointer", minHeight: "100px" }}
    >
      <div className="d-flex flex-row align-items-center gap-3">
        <div
          className="rounded-circle  d-flex justify-content-center align-items-center text-dark"
          style={{ width: "45px", height: "45px", flexShrink: 0, backgroundColor: '#BDCBDB' }}
        >
          {getInitials(title)}
        </div>
        <h6 className="mb-0 lh-base">{title}</h6>
      </div>
    </div>
  );
};

export default DocTypeCard;
